"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});


var MonacoAceTokenizer = require('monaco-ace-tokenizer');
var oop = MonacoAceTokenizer.oop;
var TextHighlightRules = MonacoAceTokenizer.TextHighlightRules;

var TclHighlightRules = function TclHighlightRules() {

    this.$rules = {
        "start": [{
            token: "comment",
            regex: "#.*\\\\$",
            next: "commentfollow"
        }, {
            token: "comment",
            regex: "#.*$"
        }, {
            token: "support.function",
            regex: '[\\\\]$',
            next: "splitlineStart"
        }, {
            token: "text",
            regex: /\\(?:["{}\[\]$\\])/
        }, {
            token: "text",
            regex: '^|[^{][;][^}]|[/\r/]',
            next: "commandItem"
        }, {
            token: "string",
            regex: '[ ]*["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
        }, {
            token: "string",
            regex: '[ ]*["]',
            next: "qqstring"
        }, {
            token: "variable.instance",
            regex: "[$]",
            next: "variable"
        }, {
            token: "support.function",
            regex: "!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=|{\\*}|;|::"
        }, {
            token: "identifier",
            regex: "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token: "paren.lparen",
            regex: "[[{]",
            next: "commandItem"
        }, {
            token: "paren.lparen",
            regex: "[(]"
        }, {
            token: "paren.rparen",
            regex: "[\\])}]"
        }, {
            token: "text",
            regex: "\\s+"
        }],
        "commandItem": [{
            token: "comment",
            regex: "#.*\\\\$",
            next: "commentfollow"
        }, {
            token: "comment",
            regex: "#.*$",
            next: "start"
        }, {
            token: "string",
            regex: '[ ]*["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
        }, {
            token: "variable.instance",
            regex: "[$]",
            next: "variable"
        }, {
            token: "support.function",
            regex: "(?:[:][:])[a-zA-Z0-9_/]+(?:[:][:])",
            next: "commandItem"
        }, {
            token: "support.function",
            regex: "[a-zA-Z0-9_/]+(?:[:][:])",
            next: "commandItem"
        }, {
            token: "support.function",
            regex: "(?:[:][:])",
            next: "commandItem"
        }, {
            token: "paren.rparen",
            regex: "[\\])}]"
        }, {
            token: "support.function",
            regex: "!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=|{\\*}|;|::"
        }, {
            token: "keyword",
            regex: "[a-zA-Z0-9_/]+",
            next: "start"
        }],
        "commentfollow": [{
            token: "comment",
            regex: ".*\\\\$",
            next: "commentfollow"
        }, {
            token: "comment",
            regex: '.+',
            next: "start"
        }],
        "splitlineStart": [{
            token: "text",
            regex: "^.",
            next: "start"
        }],
        "variable": [{
            token: "variable.instance",
            regex: "[a-zA-Z_\\d]+(?:[(][a-zA-Z_\\d]+[)])?",
            next: "start"
        }, {
            token: "variable.instance",
            regex: "{?[a-zA-Z_\\d]+}?",
            next: "start"
        }],
        "qqstring": [{
            token: "string",
            regex: '(?:[^\\\\]|\\\\.)*?["]',
            next: "start"
        }, {
            token: "string",
            regex: '.+'
        }]
    };
};

oop.inherits(TclHighlightRules, TextHighlightRules);

exports.default = TclHighlightRules;